import React from 'react';
import b_ from 'b_';

import {DescriptionProps} from './types';

import './initial-items.css';

const b = b_.with('preset-description');

export default function Description(props: DescriptionProps) {
    const {children} = props;

    return (
        <div className={b('content', {type: 'initial'})}>
            <span className={b('description-content')}>{children}</span>
        </div>
    );
}
